var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.iterator.js
// module id = 426
// module chunks = 0